import { markRaw } from 'vue'
import type { RegisteredComponent } from '@builder.io/sdk-vue'
import BaseAccordionMenuLinks from '~/components/BaseAccordionMenuLinks.vue'

export default <RegisteredComponent>{
  name: 'Base Accordion Menu Links Comp',
  tag: 'base-accordion-menu-links-comp',
  type: 'vue',
  component: markRaw(BaseAccordionMenuLinks),
  inputs: [
    {
      name: 'items',
      friendlyName: 'List of items to show (bound data)',
      helperText:
        'This is the list of items. Make sure to bind it through Visual Editor',
      type: 'list',
      defaultValue: [
        {
          title: 'Section name?',
          content: 'Link',
          url: '#',
        },
      ],
      subFields: [
        { name: 'title', type: 'string' },
        { name: 'content', type: 'string' },
        { name: 'url', type: 'string' },
      ],
    },
    {
      name: 'allowExpandMultiple',
      friendlyName: 'Allow to expand more than one at a time',
      helperText:
        'If disabled only one item will be expanded at a time. Default: false',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'initialOpenedItems',
      friendlyName: 'Comma delimited list initial open items',
      helperText:
        'A comma separated list of items to be open initially. List starts counting from 0 up - e.g. 0 - first item, 1 - second item...',
      type: 'string',
      defaultValue: '0',
    },
  ],
}
